import React from 'react';
import styled from 'styled-components';
import { string,bool,func } from 'prop-types';
import { AccentColor } from '../../Colors';

const Label = styled.label`
    padding : 0.5rem;
    cursor : pointer;
    &:hover{
        border-bottom : solid 2px ${AccentColor};
    }
`;

const Button = styled.input.attrs({
	type:'radio'
})`
    cursor : pointer;
`;

const Text = styled.span`
    margin-left : 0.5rem;
`;

const RadioButton = ({value,onClick,onChange,checked=false, ...props}) => (
	<div {...props}>
		<Label>
			<Button checked={checked} onClick={()=>{
				onClick(checked);
			}}
			onChange={onChange}
			/>
			<Text>
				{value}
			</Text>
		</Label>
	</div>
);

RadioButton.propTypes = {
	value : string.isRequired,
	checked : bool.isRequired,
	onClick : func,
	onChange : func
};


export default RadioButton;